"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const circle_indeterminate_40_json_1 = tslib_1.__importDefault(require("../../assets/circle-indeterminate-40.json"));
const Turnstile_vue_1 = tslib_1.__importDefault(require("../Turnstile.vue"));
const ChallengeStatus_1 = require("../../enums/ChallengeStatus");
var turnstileValidationStatus;
(function (turnstileValidationStatus) {
    turnstileValidationStatus["NotApplicable"] = "NotApplicable";
    turnstileValidationStatus["InProgress"] = "InProgress";
    turnstileValidationStatus["Succeeded"] = "Succeeded";
    turnstileValidationStatus["Failed"] = "Fails";
})(turnstileValidationStatus || (turnstileValidationStatus = {}));
exports.default = vue_1.default.extend({
    name: 'tethered',
    data: () => {
        return {
            turnstileToken: '',
            turnstileError: '',
            turnstileValidationStatus: turnstileValidationStatus.NotApplicable,
        };
    },
    computed: {
        currentChallenge() {
            return this.$store.state.currentChallenge;
        },
        currentChallengeStatus() {
            return this.$store.state.challengeStatus;
        },
        getAnimationJSON() {
            return circle_indeterminate_40_json_1.default;
        },
        turnstileEnabled() {
            return this.$store.state.configuration.turnstileEnabled;
        },
        turnstileSiteKey() {
            return this.$store.state.configuration.turnstileSitekey;
        },
        errorMessage() {
            var _a;
            if (this.turnstileValidationStatus === turnstileValidationStatus.Failed)
                return this.getSiteText(`ChallengeStatus.${this.currentChallengeStatus}`, (_a = this.currentChallenge.SessionInfo) === null || _a === void 0 ? void 0 : _a.Id);
            return this.getSiteText('UsernameAndPassword.Error.WithReference', this.turnstileError);
        },
        displayError() {
            return this.turnstileError !== '' || this.turnstileValidationStatus === turnstileValidationStatus.Failed;
        },
        showTurnstile() {
            return this.turnstileValidationStatus === turnstileValidationStatus.InProgress || this.turnstileValidationStatus === turnstileValidationStatus.Failed;
        },
        showLoadingAnimation() {
            return this.turnstileValidationStatus === turnstileValidationStatus.NotApplicable || this.turnstileValidationStatus === turnstileValidationStatus.Succeeded;
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        async setTurnstileToken(token) {
            // Don't update token and submit form if we received a server-side rejection
            if (this.turnstileValidationStatus === turnstileValidationStatus.Failed)
                return;
            this.turnstileError = '';
            this.turnstileToken = token;
            await this.submitForm();
        },
        setTurnstileError(err) {
            this.turnstileError = err;
        },
        disableTurnstile() {
            // Turnstile has hit an unrecoverable problem.  Disable to not block login attempts
            this.$store.commit('setTurnstileEnableState', false);
        },
        turnstileTokenExpired() {
            this.turnstileError = '';
            this.turnstileToken = '';
        },
        async submitForm() {
            const loginCredentials = this.$store.getters.loginCredentials;
            if (this.turnstileEnabled) {
                this.$store.commit('setTurnstileToken', this.turnstileToken);
            }
            const challenge = {
                ...this.currentChallenge,
                Username: decodeURIComponent(loginCredentials.UserName),
                Password: decodeURIComponent(loginCredentials.Password),
            };
            await this.$store.dispatch('submitChallenge', challenge);
            if (this.currentChallengeStatus === ChallengeStatus_1.ChallengeStatus.BotDetected) {
                this.turnstileValidationStatus = turnstileValidationStatus.Failed;
            }
            else if (this.turnstileEnabled) {
                this.turnstileValidationStatus = turnstileValidationStatus.Succeeded;
            }
            this.$store.commit('clearLoginCredentials');
        },
    },
    components: {
        Turnstile: Turnstile_vue_1.default,
    },
    mounted() {
        if (this.turnstileEnabled) {
            this.turnstileValidationStatus = turnstileValidationStatus.InProgress;
            return;
        }
        void this.submitForm();
    },
});
